import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";
import {
  DeleteVendorCategorySlice,
  EditVendorCategorySlice,
  GetVendorCategorySlice,
} from "../../../redux/features/VendorCategoryManagementSlice";
import { Loader } from "../../../common/Loader/Loader";
import useParamsFormat from "../../../common/Params Values format/ParamsFormat";
import Pagination from "../../../common/pagination/PaginationCustom";

const VendorCategoriesList = () => {
  const dispatch = useDispatch();
  const [categoryList, setCategoryList] = useState([]);
  const [dataForSend, setDataForSend] = useState({});
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({
    search: "",
    page: 1,
  });

  const { createDataSetParams } = useParamsFormat();

  const { loading, createdCategory, EditedCategory, DeleteCategory } = useSelector(
    (state) => state.VendorCategoryManagement
  );

  const fetchList = (search = getSearch) => {
    dispatch(GetVendorCategorySlice(createDataSetParams(search))).then((res) => {
      setCategoryList(res?.payload?.data?.category);
      setPagination(res?.payload?.data?.pagination);
    });
  };

  useEffect(() => {
    fetchList();
  }, [createdCategory, EditedCategory, DeleteCategory]);

  useEffect(() => {
    if (Object.entries(pagination ?? {}).length > 0) {
      setArr(
        [...Array(pagination?.totalPages + 1).keys()]
          .slice(1)
          .slice(handleArrforPage - 1, handleArrforPage + 3)
      );
    }
  }, [pagination, handleArrforPage]);

  const handlePagesIncrease = () => {
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);
    const updatedSearch = { ...getSearch, page: pageNum };
    setGetSearch(updatedSearch);
    fetchList(updatedSearch);
  };

  const handleSearch = (e) => {
    const updatedSearch = { ...getSearch, search: e.target.value, page: 1 };
    setGetSearch(updatedSearch);
    setPage(1);
    fetchList(updatedSearch);
  };

  const handleDelete = () => {
    dispatch(DeleteVendorCategorySlice(dataForSend?.id)).then(() => {
      fetchList();
    });
  };

  const handleToggleStatus = (item) => {
    dispatch(
      EditVendorCategorySlice({
        id: item?._id,
        data: { isActive: !item?.isActive },
      })
    ).then(() => {
      fetchList();
    });
  };

  return (
    <>
      <div className="Small-Wrapper">
        <div className="Filter justify-content-between">
          <div className="FilterLeft">
            <div className="form-group">
              <label>Search</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search category name"
                value={getSearch.search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="TitleBox">
        <h2>List of Vendor Categories</h2>
        <Link
          to={"AddVendorCategory"}
          data-toggle="modal"
          data-target="#AddVendorCategory"
          className="Button"
        >
          Add new
        </Link>
      </div>
      <div className="TableList">
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Category Name</th>
              <th>Description</th>
              <th>Vendors in Category</th>
              <th>Created On</th>
              <th>Status</th>
              <th>Change Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              Array.isArray(categoryList) && categoryList?.length > 0 ? (
                categoryList?.map((item, index) => {
                  return (
                    <tr key={item?._id || index}>
                      <td>{(pagination?.currentPage - 1) * 10 + index + 1}</td>
                      <td>{item?.categoryName}</td>
                      <td>{item?.description}</td>
                      <td>{item?.vendorCount}</td>
                      <td>{item?.createdAt?.substring(0, 10)}</td>
                      <td>
                        <span className={item?.isActive ? "Green" : "Red"}>
                          {item?.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <div className="Actions">
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={item?.isActive}
                              onChange={() => handleToggleStatus(item)}
                            />
                            <span className="slider" />
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="Actions">
                          <Link
                            to={`EditVendorCategory/${item._id}`}
                            className="Green"
                            data-toggle="modal"
                            data-target="#EditVendorCategory"
                            state={item}
                          >
                            <i className="fa fa-pencil" />
                          </Link>
                          <a
                            className="Red"
                            data-toggle="modal"
                            data-target="#DeleteModal"
                            onClick={() =>
                              setDataForSend((prev) => ({ ...prev, id: item?._id }))
                            }
                          >
                            <i className="fa fa-trash" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={8}>There is no vendor category</td>
                </tr>
              )
            ) : (
              <Loader />
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <Pagination
          arr={arr}
          page={page}
          handlePagesIncrease={handlePagesIncrease}
          FetchDataOnPages={FetchDataOnPages}
          handlePagesDecrease={handlePagesDecrease}
        />
      </div>
      <div className="ModalBox">
        <div id="DeleteModal" className="modal fade" style={{ display: "none" }} aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a href="javascript:void(0);" className="CloseModal" data-dismiss="modal">
                    ×
                  </a>
                  <h3>Delete</h3>
                  <p>Are you sure you want to Delete this Vendor Category?</p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="javascript:void(0);" data-dismiss="modal" onClick={handleDelete}>
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Outlet />
    </>
  );
};

export default VendorCategoriesList;
